import { render, staticRenderFns } from "./GestioneAttivitaAttivitaEditPage.vue?vue&type=template&id=4fb3ec76"
import script from "./GestioneAttivitaAttivitaEditPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaAttivitaEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports